import * as React from 'react';
import { useEffect, useState } from 'react';
import { Tabs, Tab, Spinner } from 'native-base';
import { DataTable } from 'react-native-paper';
import CalCalDataApi from '../../api/CalCalDataApi';
import useScreenDimensions from '../../hooks/screenDimensions';
import Table from '../../components/table';
import { isArray, sortBy } from 'lodash';

export default function TableLocal({ apiPath, filter, jwt, selected, onSelect, cols, onDataChange }) {
	const [data, setData] = useState([]);
	const [sort, setSort] = useState('name');
	const [direction, setDirection] = useState('ascending');
	const [loading, setLoading] = useState(true);

	useEffect(() => {
		CalCalDataApi.dataLoad(`${apiPath}/${filter}`, jwt, res => {
			if (isArray(res)) setData(res);
			if (onDataChange) onDataChange(res);
			setLoading(false);
		});
	}, [filter]);

	const changeSort = sortby => {
		if (sortby == sort) {
			setDirection(direction == 'ascending' ? 'descending' : 'ascending');
		} else {
			setDirection('ascending');
		}

		setSort(sortby);
	};

	//const { width, height } = useScreenDimensions();
	return (
		<Table
			cols={cols}
			sort={sort}
			direction={direction}
			setSort={changeSort}
			data={direction == 'ascending' ? sortBy(data, sort) : sortBy(data, sort).reverse()}
			//colAlt="#EEE"
			rowAlt="#EEEEEF"
			selectedId={selected && selected.id}
			onRowPress={onSelect}
			loading={loading}
		/>
	);
}
